<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" fxFlexFill>

    <!-- <app-languages class="abs-centered"></app-languages> -->

    <i class="great-ico fa fa-check-circle" style="font-size: 5em;"></i>

    <div class="mat-headline text-center" ngClass.xs="mat-title" [innerHTML]="'verifemail.message.verified' | translate:{'email': currEmail}"></div>

    <button color="primary" mat-raised-button (click)="goHome()" angulartics2On="click" angularticsAction="redirectCustomerSpace" angularticsCategory="emailValidation">{{"main.word.login" | translate}}</button>

</div>